var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", layout: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            xs6: "",
                            sm6: "",
                            layout: "",
                            "align-center": "",
                            "justify-start": ""
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", dark: "" },
                              on: { click: _vm.handleClose }
                            },
                            [
                              _c("v-icon", { attrs: { color: "#ffff" } }, [
                                _vm._v("close")
                              ])
                            ],
                            1
                          ),
                          _c("v-toolbar-title", [
                            _vm._v(
                              "\n              Editar Baja Cobranza " +
                                _vm._s(_vm.data.nombre_baja_cobranza) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      ),
                      !_vm.statusFinished
                        ? _c(
                            "v-flex",
                            {
                              attrs: {
                                xs6: "",
                                sm6: "",
                                layout: "",
                                "align-center": "",
                                "justify-end": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "pr-3",
                                  attrs: {
                                    color: "rgb(255 108 0)",
                                    disabled: _vm.disabledBtn
                                  },
                                  on: { click: _vm.handleEdit }
                                },
                                [
                                  _vm._v(
                                    "\n              Guardar Cambios\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { sm12: "" } },
                                      [
                                        _c(
                                          "v-tabs-items",
                                          {
                                            model: {
                                              value: _vm.tabs,
                                              callback: function($$v) {
                                                _vm.tabs = $$v
                                              },
                                              expression: "tabs"
                                            }
                                          },
                                          [
                                            _c(
                                              "h2",
                                              { staticClass: "h2_title" },
                                              [_vm._v("Editar Baja Cobranza")]
                                            ),
                                            _c("v-divider"),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  s12: "",
                                                  sm12: "",
                                                  "my-4": "",
                                                  layout: "",
                                                  wrap: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Cantidad Epc",
                                                        type: "number",
                                                        min: "0",
                                                        max: "9999999",
                                                        "prepend-icon": "123",
                                                        required: "",
                                                        counter: 7,
                                                        rules: [
                                                          _vm.rules.cantidad_epc
                                                        ],
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .cantidad_epc,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "cantidad_epc",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.cantidad_epc"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: "Observaciones",
                                                        "prepend-icon": "abc",
                                                        required: "",
                                                        rules: [
                                                          _vm.rules
                                                            .observaciones
                                                        ],
                                                        counter: 150,
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .observaciones,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "observaciones",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.observaciones"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "Nombre Tramo Baja Temporal",
                                                        "prepend-icon": "abc",
                                                        required: "",
                                                        rules: [
                                                          _vm.rules
                                                            .nombre_tramo_baja_temporal
                                                        ],
                                                        counter: 150,
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .nombre_tramo_baja_temporal,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "nombre_tramo_baja_temporal",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.nombre_tramo_baja_temporal"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label:
                                                          "Nombre Tramo Baja Definitiva",
                                                        "prepend-icon": "abc",
                                                        required: "",
                                                        rules: [
                                                          _vm.rules
                                                            .nombre_tramo_baja_definitiva
                                                        ],
                                                        counter: 150,
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .nombre_tramo_baja_definitiva,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "nombre_tramo_baja_definitiva",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.nombre_tramo_baja_definitiva"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("DatePicker", {
                                                      attrs: {
                                                        label:
                                                          "Fecha Recuperación Cliente",
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .fecha_recuperacion_cliente,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "fecha_recuperacion_cliente",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.fecha_recuperacion_cliente"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("DatePicker", {
                                                      attrs: {
                                                        label:
                                                          "Fecha Ingreso Baja Definitiva",
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .fecha_ingreso_baja_definitiva,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "fecha_ingreso_baja_definitiva",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.fecha_ingreso_baja_definitiva"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm4: "" }
                                                  },
                                                  [
                                                    _c("DatePicker", {
                                                      attrs: {
                                                        label:
                                                          "Fecha Ingreso Baja Temporal",
                                                        required: "",
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .fecha_ingreso_baja_temporal,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "fecha_ingreso_baja_temporal",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.fecha_ingreso_baja_temporal"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    attrs: { xs12: "", sm8: "" }
                                                  },
                                                  [
                                                    _c("v-textarea", {
                                                      attrs: {
                                                        label: "Descipción",
                                                        "prepend-icon": "abc",
                                                        required: "",
                                                        rules: [
                                                          _vm.rules.descripcion
                                                        ],
                                                        counter: 300,
                                                        disabled:
                                                          _vm.statusFinished
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.paramApi
                                                            .descripcion,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.paramApi,
                                                            "descripcion",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "paramApi.descripcion"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c("Confirmation", {
            attrs: {
              show: _vm.dialogConfirmation,
              titulo: _vm.confrmationData.title,
              mensaje: _vm.confrmationData.msg,
              textoBtnSi: _vm.confrmationData.btnAceptar,
              textoBtnNo: _vm.confrmationData.btnCancelar
            },
            on: {
              modalConfirmationEmit: function($event) {
                return _vm.handleConfirmation($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }